// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mt-module-style-normalize img,
.mt-module-style-normalize video{
  max-width: 100%;
  height: auto;
}


.mt-module-style-normalize img,
.mt-module-style-normalize svg,
.mt-module-style-normalize video,
.mt-module-style-normalize canvas,
.mt-module-style-normalize audio,
.mt-module-style-normalize iframe,
.mt-module-style-normalize embed,
.mt-module-style-normalize object {
  display: block;
  vertical-align: middle;
}

.mt-module-style-normalize .text-secondary-foreground {
  background-color: hsl(187 65% 92%) !important;
}
.mt-module-style-normalize .bg-secondary {
  background-color: hsl(187 65% 92%) !important;
}
.mt-module-style-normalize .p-4 {
  padding: 1rem !important;
}
.mt-module-style-normalize .p-5 {
  padding: 1.25rem !important;
}
.mt-module-style-normalize .group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100, .mt-module-style-normalize .group:hover .group-hover\\:opacity-100 {
  opacity: 1 !important;
}

body > *:not(.mt-module-style-normalize) img,
body > *:not(.mt-module-style-normalize) svg,
body > *:not(.mt-module-style-normalize) video {
  display: initial;
}
body > *:not(.mt-module-style-normalize) .collapse{
  visibility: unset;
}

.mt-module-style-normalize{
  contain: style;
}
@media (min-width: 1280px) {
  .mt-module-style-normalize .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr));
  }
  .mt-module-style-normalize .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr));
  }
  .mt-module-style-normalize .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5,minmax(0,1fr)) !important;
  } 
  .mt-module-style-normalize .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6,minmax(0,1fr)) !important;
  }
  .mt-module-style-normalize  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr)) !important;
  }
  .booking-view-top-card-view .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6,minmax(0,1fr)) !important;
  }
  .mt-module-style-normalize .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5,minmax(0,1fr)) !important;
  }
}
.mt-module-style-normalize .collapse {
  visibility: collapse;
}
.booking-calendar-view .booking-Calendar-container.flex.w-full{
  padding-left: 30px !important;
}
.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:bg-accent[aria-selected="true"] {
  background-color: hsl(198 88% 95%) !important;
}
.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:text-accent-foreground[aria-selected="true"] {
  color: hsl(198 88% 28%) !important;
}
.rdp.p-3.pointer-events-auto.rdp-multiple_months .bg-primary {
  background-color: hsl(198 88% 44%) !important;
}

.mt-dialog-style-normalize .bg-secondary {
  background-color: hsl(210 40% 96.1%);
}
.mt-dialog-style-normalize .text-secondary-foreground {
  color: hsl(215 25% 15%);
}
.dashboard-main-container-box .bg-muted {
  background-color: hsl(0, 0%, 88.6%);
}
.dashboard-main-container-box .grid-cols-3 {
      grid-template-columns: repeat(7,minmax(0,1fr));
}
.mt-occupancy-search-calendar input{
  padding-left: 30px !important;
}
@media (min-width: 768px) {
  .mt-dialog-style-normalize .md\\:grid-cols-5 {
      grid-template-columns: repeat(5,minmax(0,1fr));
  }
  .mt-module-style-normalize .md\\:flex-row {
    flex-direction: row;
  }
  .dashboard-main-container-box .md\\:hidden {
    display: none;
  }
}
@media (max-width: 768px) {
  .dashboard-main-container-box .grid-cols-3 {
      grid-template-columns: repeat(3,minmax(0,1fr));
  }
}
@media (min-width: 640px) {
  .mt-dialog-style-normalize .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4,minmax(0,1fr));
  }
}
.view-dialog-style-normalize{
  z-index: 999 !important;
}
.mt-dialog-style-normalize .pl-9 {
  padding-left: 2.25rem !important;
}
.mt-dialog-style-normalize{
  z-index: 999 !important;
}

/* ============================================
   Variants Report Module Styles (@mt/varients-report) - SCOPED ONLY
   ============================================ */

/* Theme variables for variants-report only - will not affect other modules */
.mt-variants-report-wrapper {
  --background: 210 20% 98%;
  --foreground: 222 47% 11%;
  --card: 0 0% 100%;
  --card-foreground: 222 47% 11%;
  --popover: 0 0% 100%;
  --popover-foreground: 222 47% 11%;
  --primary: 160 84% 29%;
  --primary-foreground: 0 0% 100%;
  --secondary: 210 40% 96%;
  --secondary-foreground: 222 47% 11%;
  --muted: 210 30% 95%;
  --muted-foreground: 215 16% 47%;
  --accent: 160 60% 94%;
  --accent-foreground: 160 84% 20%;
  --destructive: 0 84% 60%;
  --destructive-foreground: 0 0% 100%;
  --border: 214 32% 91%;
  --input: 214 32% 91%;
  --ring: 160 84% 29%;
  --radius: 0.5rem;
  --success: 142 76% 36%;
  --success-foreground: 0 0% 100%;
  --warning: 38 92% 50%;
  --warning-foreground: 0 0% 100%;
  --info: 217 91% 60%;
  --info-foreground: 0 0% 100%;
}

/* Fix for react-js-cron select elements - ONLY in variants-report */
.mt-variants-report-wrapper .react-js-cron select,
.mt-variants-report-wrapper .react-js-cron-select,
.mt-variants-report-wrapper .react-js-cron-field select,
.mt-variants-report-wrapper [class*="react-js-cron"] select {
  position: relative !important;
  z-index: 99999 !important;
  pointer-events: auto !important;
  -webkit-appearance: menulist !important;
  appearance: menulist !important;
}

/* Ensure dropdown menus work properly in variants-report */
.mt-variants-report-wrapper .react-js-cron-select option,
.mt-variants-report-wrapper .react-js-cron select option,
.mt-variants-report-wrapper select option {
  pointer-events: auto !important;
  background-color: white !important;
  color: black !important;
  padding: 8px !important;
}

/* Make sure cron container allows interaction in variants-report */
.mt-variants-report-wrapper .cron-builder,
.mt-variants-report-wrapper .react-js-cron,
.mt-variants-report-wrapper .react-js-cron * {
  pointer-events: auto !important;
}

/* Ensure parent containers don't block in variants-report */
.mt-variants-report-wrapper div:has(.react-js-cron) {
  pointer-events: auto !important;
}

.roomTypeModal.max-w-3xl {
  max-width: 55rem !important;
}

/* ============================================
   Sonner Toast Notifications - Complete Styling
   ============================================ */

/* Toast container positioning and z-index */
.toastifyContainer,
[data-sonner-toaster] {
  position: fixed !important;
  z-index: 999999 !important;
  pointer-events: none !important;
}

/* Position variants */
[data-sonner-toaster][data-x-position="right"] {
  right: 0 !important;
}

[data-sonner-toaster][data-y-position="bottom"] {
  bottom: 0 !important;
}

[data-sonner-toaster][data-y-position="top"] {
  top: 0 !important;
}

/* Individual toast items */
[data-sonner-toast] {
  z-index: 999999 !important;
  pointer-events: auto !important;
  opacity: 1 !important;
  visibility: visible !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 12px 16px !important;
  margin-bottom: 14px !important;
  border-radius: 8px !important;
  background-color: white !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  min-width: 300px !important;
  max-width: 420px !important;
}

/* Toast visible state */
[data-sonner-toast][data-visible="true"] {
  opacity: 1 !important;
  transform: translateY(0) !important;
}

/* Toast type colors */
[data-sonner-toast][data-type="error"] {
  background-color: #fef2f2 !important;
  border-color: #fecaca !important;
  color: #991b1b !important;
}

[data-sonner-toast][data-type="success"] {
  background-color: #f0fdf4 !important;
  border-color: #bbf7d0 !important;
  color: #166534 !important;
}

[data-sonner-toast][data-type="warning"] {
  background-color: #fffbeb !important;
  border-color: #fde68a !important;
  color: #92400e !important;
}

[data-sonner-toast][data-type="info"] {
  background-color: #eff6ff !important;
  border-color: #bfdbfe !important;
  color: #1e40af !important;
}

/* Toast icon */
[data-sonner-toast] [data-icon] {
  display: flex !important;
  align-items: center !important;
  flex-shrink: 0 !important;
}

[data-sonner-toast] [data-icon] svg {
  width: 20px !important;
  height: 20px !important;
}

/* Toast content */
[data-sonner-toast] [data-content] {
  flex: 1 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
}

[data-sonner-toast] [data-title] {
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
}

[data-sonner-toast] [data-description] {
  font-size: 13px !important;
  opacity: 0.9 !important;
  line-height: 1.4 !important;
}

/* Toast group/container */
.toaster.group {
  z-index: 999999 !important;
  list-style: none !important;
  margin: 0 !important;
  padding: 16px !important;
}

/* Ensure toast content is visible */
.toast.group {
  pointer-events: auto !important;
}

.mt-dialog-style-banquet-functional-planning{
  z-index: 99999 !important;
}`, "",{"version":3,"sources":["webpack://./src/Utility/Public/css/mt-modules-scoped.css"],"names":[],"mappings":"AAAA;;EAEE,eAAe;EACf,YAAY;AACd;;;AAGA;;;;;;;;EAQE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;AACA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,8CAA8C;EAChD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,yDAAyD;EAC3D;AACF;AACA;EACE,oBAAoB;AACtB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,kCAAkC;AACpC;AACA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mCAAmC;AACrC;AACA;MACM,8CAA8C;AACpD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;MACI,8CAA8C;EAClD;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;MACI,8CAA8C;EAClD;AACF;AACA;EACE;IACE,8CAA8C;EAChD;AACF;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD,6EAA6E;AAC7E;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,8BAA8B;EAC9B,oBAAoB;EACpB,iCAAiC;EACjC,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;EACxB,mCAAmC;EACnC,oBAAoB;EACpB,+BAA+B;EAC/B,qBAAqB;EACrB,gCAAgC;EAChC,wBAAwB;EACxB,mCAAmC;EACnC,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,oEAAoE;AACpE;;;;EAIE,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;EAC/B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA,2DAA2D;AAC3D;;;EAGE,+BAA+B;EAC/B,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,mEAAmE;AACnE;;;EAGE,+BAA+B;AACjC;;AAEA,4DAA4D;AAC5D;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;iDAEiD;;AAEjD,4CAA4C;AAC5C;;EAEE,0BAA0B;EAC1B,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qBAAqB;EACrB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;EAClC,oCAAoC;EACpC,qDAAqD;EACrD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".mt-module-style-normalize img,\n.mt-module-style-normalize video{\n  max-width: 100%;\n  height: auto;\n}\n\n\n.mt-module-style-normalize img,\n.mt-module-style-normalize svg,\n.mt-module-style-normalize video,\n.mt-module-style-normalize canvas,\n.mt-module-style-normalize audio,\n.mt-module-style-normalize iframe,\n.mt-module-style-normalize embed,\n.mt-module-style-normalize object {\n  display: block;\n  vertical-align: middle;\n}\n\n.mt-module-style-normalize .text-secondary-foreground {\n  background-color: hsl(187 65% 92%) !important;\n}\n.mt-module-style-normalize .bg-secondary {\n  background-color: hsl(187 65% 92%) !important;\n}\n.mt-module-style-normalize .p-4 {\n  padding: 1rem !important;\n}\n.mt-module-style-normalize .p-5 {\n  padding: 1.25rem !important;\n}\n.mt-module-style-normalize .group\\/menu-item:hover .group-hover\\/menu-item\\:opacity-100, .mt-module-style-normalize .group:hover .group-hover\\:opacity-100 {\n  opacity: 1 !important;\n}\n\nbody > *:not(.mt-module-style-normalize) img,\nbody > *:not(.mt-module-style-normalize) svg,\nbody > *:not(.mt-module-style-normalize) video {\n  display: initial;\n}\nbody > *:not(.mt-module-style-normalize) .collapse{\n  visibility: unset;\n}\n\n.mt-module-style-normalize{\n  contain: style;\n}\n@media (min-width: 1280px) {\n  .mt-module-style-normalize .xl\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr));\n  }\n  .mt-module-style-normalize .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr));\n  }\n  .mt-module-style-normalize .lg\\:grid-cols-5 {\n    grid-template-columns: repeat(5,minmax(0,1fr)) !important;\n  } \n  .mt-module-style-normalize .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6,minmax(0,1fr)) !important;\n  }\n  .mt-module-style-normalize  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr)) !important;\n  }\n  .booking-view-top-card-view .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6,minmax(0,1fr)) !important;\n  }\n  .mt-module-style-normalize .xl\\:grid-cols-5 {\n    grid-template-columns: repeat(5,minmax(0,1fr)) !important;\n  }\n}\n.mt-module-style-normalize .collapse {\n  visibility: collapse;\n}\n.booking-calendar-view .booking-Calendar-container.flex.w-full{\n  padding-left: 30px !important;\n}\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:bg-accent[aria-selected=\"true\"] {\n  background-color: hsl(198 88% 95%) !important;\n}\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .aria-selected\\:text-accent-foreground[aria-selected=\"true\"] {\n  color: hsl(198 88% 28%) !important;\n}\n.rdp.p-3.pointer-events-auto.rdp-multiple_months .bg-primary {\n  background-color: hsl(198 88% 44%) !important;\n}\n\n.mt-dialog-style-normalize .bg-secondary {\n  background-color: hsl(210 40% 96.1%);\n}\n.mt-dialog-style-normalize .text-secondary-foreground {\n  color: hsl(215 25% 15%);\n}\n.dashboard-main-container-box .bg-muted {\n  background-color: hsl(0, 0%, 88.6%);\n}\n.dashboard-main-container-box .grid-cols-3 {\n      grid-template-columns: repeat(7,minmax(0,1fr));\n}\n.mt-occupancy-search-calendar input{\n  padding-left: 30px !important;\n}\n@media (min-width: 768px) {\n  .mt-dialog-style-normalize .md\\:grid-cols-5 {\n      grid-template-columns: repeat(5,minmax(0,1fr));\n  }\n  .mt-module-style-normalize .md\\:flex-row {\n    flex-direction: row;\n  }\n  .dashboard-main-container-box .md\\:hidden {\n    display: none;\n  }\n}\n@media (max-width: 768px) {\n  .dashboard-main-container-box .grid-cols-3 {\n      grid-template-columns: repeat(3,minmax(0,1fr));\n  }\n}\n@media (min-width: 640px) {\n  .mt-dialog-style-normalize .sm\\:grid-cols-4 {\n    grid-template-columns: repeat(4,minmax(0,1fr));\n  }\n}\n.view-dialog-style-normalize{\n  z-index: 999 !important;\n}\n.mt-dialog-style-normalize .pl-9 {\n  padding-left: 2.25rem !important;\n}\n.mt-dialog-style-normalize{\n  z-index: 999 !important;\n}\n\n/* ============================================\n   Variants Report Module Styles (@mt/varients-report) - SCOPED ONLY\n   ============================================ */\n\n/* Theme variables for variants-report only - will not affect other modules */\n.mt-variants-report-wrapper {\n  --background: 210 20% 98%;\n  --foreground: 222 47% 11%;\n  --card: 0 0% 100%;\n  --card-foreground: 222 47% 11%;\n  --popover: 0 0% 100%;\n  --popover-foreground: 222 47% 11%;\n  --primary: 160 84% 29%;\n  --primary-foreground: 0 0% 100%;\n  --secondary: 210 40% 96%;\n  --secondary-foreground: 222 47% 11%;\n  --muted: 210 30% 95%;\n  --muted-foreground: 215 16% 47%;\n  --accent: 160 60% 94%;\n  --accent-foreground: 160 84% 20%;\n  --destructive: 0 84% 60%;\n  --destructive-foreground: 0 0% 100%;\n  --border: 214 32% 91%;\n  --input: 214 32% 91%;\n  --ring: 160 84% 29%;\n  --radius: 0.5rem;\n  --success: 142 76% 36%;\n  --success-foreground: 0 0% 100%;\n  --warning: 38 92% 50%;\n  --warning-foreground: 0 0% 100%;\n  --info: 217 91% 60%;\n  --info-foreground: 0 0% 100%;\n}\n\n/* Fix for react-js-cron select elements - ONLY in variants-report */\n.mt-variants-report-wrapper .react-js-cron select,\n.mt-variants-report-wrapper .react-js-cron-select,\n.mt-variants-report-wrapper .react-js-cron-field select,\n.mt-variants-report-wrapper [class*=\"react-js-cron\"] select {\n  position: relative !important;\n  z-index: 99999 !important;\n  pointer-events: auto !important;\n  -webkit-appearance: menulist !important;\n  appearance: menulist !important;\n}\n\n/* Ensure dropdown menus work properly in variants-report */\n.mt-variants-report-wrapper .react-js-cron-select option,\n.mt-variants-report-wrapper .react-js-cron select option,\n.mt-variants-report-wrapper select option {\n  pointer-events: auto !important;\n  background-color: white !important;\n  color: black !important;\n  padding: 8px !important;\n}\n\n/* Make sure cron container allows interaction in variants-report */\n.mt-variants-report-wrapper .cron-builder,\n.mt-variants-report-wrapper .react-js-cron,\n.mt-variants-report-wrapper .react-js-cron * {\n  pointer-events: auto !important;\n}\n\n/* Ensure parent containers don't block in variants-report */\n.mt-variants-report-wrapper div:has(.react-js-cron) {\n  pointer-events: auto !important;\n}\n\n.roomTypeModal.max-w-3xl {\n  max-width: 55rem !important;\n}\n\n/* ============================================\n   Sonner Toast Notifications - Complete Styling\n   ============================================ */\n\n/* Toast container positioning and z-index */\n.toastifyContainer,\n[data-sonner-toaster] {\n  position: fixed !important;\n  z-index: 999999 !important;\n  pointer-events: none !important;\n}\n\n/* Position variants */\n[data-sonner-toaster][data-x-position=\"right\"] {\n  right: 0 !important;\n}\n\n[data-sonner-toaster][data-y-position=\"bottom\"] {\n  bottom: 0 !important;\n}\n\n[data-sonner-toaster][data-y-position=\"top\"] {\n  top: 0 !important;\n}\n\n/* Individual toast items */\n[data-sonner-toast] {\n  z-index: 999999 !important;\n  pointer-events: auto !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  padding: 12px 16px !important;\n  margin-bottom: 14px !important;\n  border-radius: 8px !important;\n  background-color: white !important;\n  border: 1px solid #e5e7eb !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  min-width: 300px !important;\n  max-width: 420px !important;\n}\n\n/* Toast visible state */\n[data-sonner-toast][data-visible=\"true\"] {\n  opacity: 1 !important;\n  transform: translateY(0) !important;\n}\n\n/* Toast type colors */\n[data-sonner-toast][data-type=\"error\"] {\n  background-color: #fef2f2 !important;\n  border-color: #fecaca !important;\n  color: #991b1b !important;\n}\n\n[data-sonner-toast][data-type=\"success\"] {\n  background-color: #f0fdf4 !important;\n  border-color: #bbf7d0 !important;\n  color: #166534 !important;\n}\n\n[data-sonner-toast][data-type=\"warning\"] {\n  background-color: #fffbeb !important;\n  border-color: #fde68a !important;\n  color: #92400e !important;\n}\n\n[data-sonner-toast][data-type=\"info\"] {\n  background-color: #eff6ff !important;\n  border-color: #bfdbfe !important;\n  color: #1e40af !important;\n}\n\n/* Toast icon */\n[data-sonner-toast] [data-icon] {\n  display: flex !important;\n  align-items: center !important;\n  flex-shrink: 0 !important;\n}\n\n[data-sonner-toast] [data-icon] svg {\n  width: 20px !important;\n  height: 20px !important;\n}\n\n/* Toast content */\n[data-sonner-toast] [data-content] {\n  flex: 1 !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 4px !important;\n}\n\n[data-sonner-toast] [data-title] {\n  font-weight: 500 !important;\n  font-size: 14px !important;\n  line-height: 1.4 !important;\n}\n\n[data-sonner-toast] [data-description] {\n  font-size: 13px !important;\n  opacity: 0.9 !important;\n  line-height: 1.4 !important;\n}\n\n/* Toast group/container */\n.toaster.group {\n  z-index: 999999 !important;\n  list-style: none !important;\n  margin: 0 !important;\n  padding: 16px !important;\n}\n\n/* Ensure toast content is visible */\n.toast.group {\n  pointer-events: auto !important;\n}\n\n.mt-dialog-style-banquet-functional-planning{\n  z-index: 99999 !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
